import './init-sw';
import Vue from 'vue';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginVue from '@bugsnag/plugin-vue';
import FallingCards from '@/components/FallingCards';
import GoogleInstallPrompt from '@/components/GoogleInstallPrompt';
import IosInstallPrompt from '@/components/IosInstallPrompt';
import Loader from '@/components/Loader';
import ReJoinGame from '@/components/ReJoinGame';

Bugsnag.start({
    apiKey: '06b04c11ffcf49fba0aa2058287026f7',
    plugins: [new BugsnagPluginVue(Vue)],
    enabledReleaseStages: ['production', 'development'],
    releaseStage: process.env.MIX_APP_ENV,
});

new Vue({
    el: '#home',
    data: {
        submitted: false,
    },
    components: {
        FallingCards,
        GoogleInstallPrompt,
        IosInstallPrompt,
        Loader,
        ReJoinGame,
    },
});
